import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [categoryOpen, setCategoryOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setCategoryOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`flex items-center gap-2 whitespace-nowrap cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            <span className="w-8 h-8 flex items-center justify-center">
              <i className="ri-book-read-line text-2xl"></i>
            </span>
            <span className="text-xl font-heading font-bold tracking-wide">布丁漫画</span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:text-primary-500 ${
                location.pathname === '/' ? 'text-primary-500' : scrolled || !isHome ? 'text-foreground-700' : 'text-background-50/90'
              }`}
            >
              首页
            </Link>

            <div className="relative">
              <button
                onClick={() => setCategoryOpen(!categoryOpen)}
                className={`flex items-center gap-1 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:text-primary-500 ${
                  location.pathname.startsWith('/category') ? 'text-primary-500' : scrolled || !isHome ? 'text-foreground-700' : 'text-background-50/90'
                }`}
              >
                分类
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={`ri-arrow-down-s-line text-sm transition-transform ${categoryOpen ? 'rotate-180' : ''}`}></i>
                </span>
              </button>
              {categoryOpen && (
                <>
                  <div className="fixed inset-0 z-10" onClick={() => setCategoryOpen(false)}></div>
                  <div className="absolute top-full left-0 mt-2 w-48 bg-background-50 rounded-lg border border-background-200/70 py-2 z-20">
                    {categories.map((cat) => (
                      <Link
                        key={cat.slug}
                        to={`/category/${cat.slug}`}
                        className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                      >
                        <span className="w-5 h-5 flex items-center justify-center">
                          <i className={`${cat.icon} text-sm`}></i>
                        </span>
                        {cat.name}
                        <span className="ml-auto text-xs text-foreground-400">{cat.count}</span>
                      </Link>
                    ))}
                  </div>
                </>
              )}
            </div>

            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap cursor-pointer transition-colors hover:text-primary-500 ${
                location.pathname === '/about' ? 'text-primary-500' : scrolled || !isHome ? 'text-foreground-700' : 'text-background-50/90'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap">
              <i className={`ri-search-line text-sm ${scrolled || !isHome ? 'text-foreground-600' : 'text-background-50'}`}></i>
            </button>
            <Link
              to="/category/hanman"
              className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              开始阅读
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled || !isHome ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-2">
            <Link
              to="/"
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              首页
            </Link>
            <div className="px-4 py-2 text-xs font-medium text-foreground-400 uppercase">漫画分类</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-3 px-4 py-3 text-sm text-foreground-700 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={cat.icon}></i>
                </span>
                {cat.name}
                <span className="ml-auto text-xs text-foreground-400">{cat.count}</span>
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:bg-primary-50 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              关于我们
            </Link>
            <Link
              to="/category/hanman"
              className="mt-2 px-4 py-3 text-sm font-medium text-center bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}